import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import TrackOrder from './pages/TrackOrder';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<TrackOrder />} />
            <Route path="/track" element={<TrackOrder />} />
          </Routes>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
